import { render, staticRenderFns } from "./FollowupsTabs.vue?vue&type=template&id=b22204bc&scoped=true"
import script from "./FollowupsTabs.vue?vue&type=script&lang=js"
export * from "./FollowupsTabs.vue?vue&type=script&lang=js"
import style0 from "./FollowupsTabs.vue?vue&type=style&index=0&id=b22204bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22204bc",
  null
  
)

export default component.exports